import { useState } from "react"
import Popover from "@mui/material/Popover"
import { Pencil } from "lucide-react"

// Single-line preview in a narrow table cell; click opens a larger textarea bubble anchored to it.
export default function NoteBubbleField({ value, onChange, placeholder, style }) {
  const [anchorEl, setAnchorEl] = useState(null)

  return (
    <>
      <button
        type="button"
        onClick={(e) => setAnchorEl(e.currentTarget)}
        title={value || placeholder}
        style={{ ...previewStyle, ...style, color: value ? "#344054" : "#98a2b3" }}
      >
        <span style={{ flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
          {value || placeholder}
        </span>
        <Pencil size={13} color="#98a2b3" style={{ flexShrink: 0 }} />
      </button>
      <Popover
        open={!!anchorEl}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        PaperProps={{ sx: { p: 1.5, mt: 0.5, borderRadius: 2, width: 380, maxWidth: "calc(100vw - 32px)" } }}
      >
        <textarea
          autoFocus
          rows={6}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onFocus={(e) => e.target.setSelectionRange(e.target.value.length, e.target.value.length)}
          style={textareaStyle}
        />
        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 8 }}>
          <button type="button" onClick={() => setAnchorEl(null)} style={doneStyle}>
            Xong
          </button>
        </div>
      </Popover>
    </>
  )
}

const previewStyle = {
  display: "flex",
  alignItems: "center",
  gap: 6,
  width: "100%",
  padding: "6px 8px",
  border: "1px solid #e2e6ed",
  borderRadius: 6,
  fontSize: 13,
  background: "#fff",
  cursor: "text",
  textAlign: "left",
}

const textareaStyle = {
  width: "100%",
  padding: "8px 10px",
  border: "1px solid #e2e6ed",
  borderRadius: 6,
  fontSize: 13,
  fontFamily: "inherit",
  resize: "vertical",
  boxSizing: "border-box",
}

const doneStyle = {
  padding: "5px 14px",
  border: "none",
  borderRadius: 6,
  background: "#1d4ed8",
  color: "#fff",
  fontSize: 13,
  cursor: "pointer",
}
